import { render } from "./Registered.vue?vue&type=template&id=b701f770&scoped=true"
const script = {}

import "./Registered.vue?vue&type=style&index=0&id=b701f770&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b701f770"

export default script